import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt, faMountain, faRoad,
} from '@fortawesome/free-solid-svg-icons';

const CategoryAward = ({ category }) => {
  const icon = () => {
    switch (category) {
      case 'road':
        return faRoad;
      case 'mountain':
        return faMountain;
      case 'ebike':
      default:
        return faBolt;
    }
  };

  const title = () => {
    switch (category) {
      case 'road':
        return 'Víťaz disciplíny v cestných bicykloch';
      case 'mountain':
        return 'Víťaz disciplíny v horských bicykloch';
      case 'ebike':
        return 'Víťaz disciplíny v elektrických bicykloch';
      default:
        return '';
    }
  };

  return (
    <FontAwesomeIcon
      icon={icon()}
      title={title()}
      style={{ margin: '0em .5em', color: '#ffbf00' }}
    />
  );
};

CategoryAward.propTypes = {
  category: PropTypes.string.isRequired,
};

export default CategoryAward;
